import React from 'react'

import { t } from 'src/translations'

import { Channel } from 'public/js/siteUtilities'
import { useCart } from 'public/components/online_ordering/CartContext'

import EyeglassesIcon from './EyeglassesIcon'

type Entity = 'product' | 'menu-item'
type State = 'filtered' | 'empty'

export type NoAvailableMenuItemsProps = {
  /**
   * Whether the empty state is the result of an active filter.
   * When true, the copy invites the guest to adjust their filters.
   * When false it communicates that nothing is available at all.
   */
  isFiltered?: boolean
}

export const NoAvailableMenuItems = ({
  isFiltered = false
}: NoAvailableMenuItemsProps) => {
  const { channel } = useCart()

  // The ecomm storefront refers to "products"; online ordering uses "menu items".
  const entity: Entity = channel === Channel.ECOMM ? 'product' : 'menu-item'
  const state: State = isFiltered ? 'filtered' : 'empty'

  return (
    <div className='paddedContentWrapper'>
      <div className='paddedContent noAvailableMenuItems'>
        {/* The icon is decorative and marked as aria-hidden */}
        {/* eslint-disable-next-line @toasttab/buffet/icon-accessibility */}
        <EyeglassesIcon />
        <div className='noAvailableMenuItemsText'>
          <h2 className='noAvailableMenuItemsTitle'>
            {t(`no-available-menu-items.${state}.${entity}.title`)}
          </h2>
          <p className='noAvailableMenuItemsSubtext'>
            {t(`no-available-menu-items.${state}.${entity}.subtext`)}
          </p>
        </div>
      </div>
    </div>
  )
}
